import { RadioGroup } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { VideoBroadcastWidgetState } from '../../../store/VideoBroadcastWidgetState';
import type { TAspectRatio } from '../../../types';
import styles from '../../VideoBroadcastWidget.module.scss';

const proportions: { value: TAspectRatio; label: string }[] = [
  { value: '1x1', label: '1x1' },
  { value: '4x3', label: '4x3' },
  { value: '16x9', label: '16x9' },
];

export const ImageAspectRatio = observer(function ImageAspectRatio({
  widgetState,
}: {
  widgetState: VideoBroadcastWidgetState;
}) {
  const { t } = useTranslation('videoBroadcastWidget', { useSuspense: false });

  return (
    <div className={styles.tooltipWrapper}>
      <div className={styles.tooltipTitle}>{t('sidebar.proportions')}</div>
      <RadioGroup
        value={widgetState.aspectRatio}
        items={proportions}
        onChange={(value) => widgetState.setAspectRatio(value)}
      />
    </div>
  );
});
